<!-- 客服侧边栏-PC端 -->
<template>
<div class="silderBox" v-if="noShowRouteName.indexOf($route.name) === -1">
    <div class="item service">
        <img class="icon" :src="require('@/common/images/common/service_icon.png')" alt="">
        <div class="label">在线客服</div>
        <div class="serviceCodeBox">
            <img :src="require('@/common/images/common/service_code.png')" class="serviceCode" alt="">
            <div class="tips">免费在线咨询</div>
            <div class="tips">快速帮您解决问题</div>
        </div>
    </div>
    <div class="line"></div>
    <div class="item">
        <img class="icon" :src="require('@/common/images/common/app_download_icon.png')" alt="">
        <img class="activeIcon" :src="require('@/common/images/common/app_download_active_icon.png')" alt="">
        <div class="label">APP下载</div>
        <div class="appDownloadCodeBox">
            <img class="appCode" :src="require('@/common/images/common/app_code.png')" alt="">
            <div class="tips">
                <div class="tipsItem">鲸融网APP</div>
                <div class="tipsItem2">投资投行服务平台</div>
            </div>
        </div>
    </div>
    <div class="line"></div>
    <div class="item">
        <img class="icon" :src="require('@/common/images/common/code_icon.png')" alt="">
        <img class="activeIcon" :src="require('@/common/images/common/code_active_icon.png')" alt="">
        <div class="label">公众号</div>
        <div class="codeBox">
            <div class="codeItem">
                <img class="codeImg" :src="require('@/common/images/common/subscription_code1.png')" alt="">
                <div class="codename">订阅号</div>  
            </div>
            <div class="codeItem">
                <img class="codeImg" :src="require('@/common/images/common/subscription_code2.png')" alt="">
                <div class="codename">服务号</div>  
            </div>
        </div>
    </div>
    <div class="line"></div>
    <div class="item" @click="handleGoTop">
        <img class="icon" :src="require('@/common/images/common/go_top_icon.png')" alt="">
        <img class="activeIcon" :src="require('@/common/images/common/go_top_active_icon.png')" alt="">
        <div class="label">返回顶部</div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            noShowRouteName: ['Study']
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleGoTop() {
            document.documentElement.scrollTop = 0
        }
    }
}
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
.silderBox {
    width: 56px;
    height: 238px;
    background: #fff;
    position: fixed;
    right: 10px;
    bottom: 100px;
    border-radius: 4px;
    box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.25);
    z-index: 10000;
    .item {
        text-align: center;
        width: 56px;
        padding: 8px 0 0;
        cursor: pointer;
        position: relative;
        &:not(:last-of-type) {
            margin-bottom: 10px;
        }
        .icon {
            width: 24px;
            height: 24px;
            margin: 0;
            display: inline;
        }
        .activeIcon {
            width: 24px;
            height: 24px;
            margin: 0;
            display: none;
        }
        .label {
            font-size: 12px;
            line-height: 14px;
        }
        &:hover {
            .icon {
                display: none;
            }
            .activeIcon {
                display: inline;
            }
            .label {
                color: #397FFF;
            }
            .serviceCodeBox {
                display: block;
            }
            .appDownloadCodeBox, .codeBox {
                display: flex;
            }
        }
        @keyframes service {
            from {
                opacity: 1;
            }
            to {
                opacity: 0;
            }
        }
        &.service {
            .label {
                color: #397FFF;
            }
            .icon {
                display: inline;
                opacity: 1;
                animation: service 1s linear 0s infinite alternate;
            }
        }
        .serviceCodeBox {
            position: absolute;
            width: 140px;
            height: 180px;
            padding: 10px;
            box-sizing: border-box;
            background: #fff;
            box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.25);
            border-radius: 4px 4px 4px 4px;
            top: 0;
            left: -160px;
            display: none;
            .serviceCode {
                width: 120px;
                height: 120px;
                margin-bottom: 5px;
            }
            .tips {
                text-align: center;
                font-size: 13px;
                color: #333333;
                line-height: 15px;
            }
        }
        .appDownloadCodeBox {
            width: 260px;
            height: 130px;
            box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.25);
            border-radius: 4px 4px 4px 4px;
            position: absolute;
            padding: 10px 0 10px 10px;
            top: -34px;
            left: -280px;
            display: none;
            align-items: center;
            background: #fff;
            box-sizing: border-box;
            .appCode {
                width: 110px;
                height: 110px;
                margin-right: 15px;
            }
            .tips {
                flex: 1;
                text-align: left;
                .tipsItem {
                    font-size: 16px;
                    color: #333333;
                    line-height: 20px;
                    margin-bottom: 8px;
                }
                .tipsItem2 {
                    font-size: 13px;
                    color: #333333;
                    line-height: 15px;
                }
            }
        }
        .codeBox {
            box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.25);
            border-radius: 4px 4px 4px 4px;
            position: absolute;
            top: -30px;
            left: -280px;
            padding: 10px;
            background: #fff;
            box-sizing: border-box;
            width: 260px;
            height: 148px;
            display: none;
            justify-content: space-between;
            .codeItem {
              .codeImg {
                  width: 110px;
                  height: 110px;
              }
              .codename {
                  text-align: center;
                  font-size: 13px;
                  color: #333333;
                  line-height: 15px;
              }
            }
        }
    }
    .line {
        width: 40px;
        height: 1px;
        background: #EEEEEE;
        margin: auto;
    }
}
</style>